import { render, staticRenderFns } from "./revisions.vue?vue&type=template&id=8f5f2c2a&scoped=true&"
import script from "./revisions.vue?vue&type=script&lang=js&"
export * from "./revisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5f2c2a",
  null
  
)

export default component.exports